"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useScale = void 0;
var _react = require("react");
var _context = require("./context");
const useScale = () => {
  return (0, _react.useContext)(_context.ScaleContext);
};
exports.useScale = useScale;